import { useShallow } from 'zustand/react/shallow'

import { useSyncStore } from '@/stores/sync.store'

/**
 * Reactive snapshot of the sync subsystem.
 *
 * Same `useShallow` discipline as `useAuth` — without it, the
 * selector returns a fresh object on every render and Zustand
 * v5 + React 18 falls into the canonical re-render loop.
 *
 * Returns the four primitives the UI cares about plus a derived
 * `hasErrors` flag so call sites don't recompute `errorCount > 0`.
 */
export function useSyncStatus() {
  return useSyncStore(
    useShallow((s) => ({
      isOnline: s.isOnline,
      wasOffline: s.wasOffline,
      syncing: s.syncing,
      pendingCount: s.pendingCount,
      errorCount: s.errorCount,
      hasErrors: s.errorCount > 0,
    })),
  )
}
